<div class="link">
  <div class="typo-21" *ngIf="expertValue">
    Cliquez sur ce <a (click)="openPdf(expertLink)">lien</a> pour ouvrir le répertoire des {{expertValue}}
  </div>
  <br/>
  <div class="typo-21" *ngIf="expertValue && carte">
    Cliquez <a (click)="openPdf(expertCarteLink)">ici</a> pour voir la carte de régionalisation des géomètres-experts en Côte d’Ivoire
  </div>
  <div class="typo-21" *ngIf="!expertValue">
    Pas de répertoire disponible
  </div>
</div>
